import React from "react";
import SideHeader from "../../private/admin/SideHeader";

const Admin = () => {
  return (
    <>
      <SideHeader />
    </>
  );
};

export default Admin;
